import React from "react";
import PropTypes from "prop-types";
import { Button, Card } from "react-bootstrap";
import Details from "./Details/Details";
import { ReactComponent as ArrowIcon } from "../Images/ArrowIcon.svg";
import "./NewsItem.css";
import { FaWhatsapp, FaFacebook, FaTwitter } from "react-icons/fa";



function NewsItem(props) {
  const { imageUrl, alt, shortDescription, title, channel, published, urlNews } = props;

  const BASE_URL = process.env.REACT_APP_API_URL || 'https://todaylocal.in/api';
  console.log("BASE_URL:", process.env.REACT_APP_API_URL);

  const handleWebShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: shortDescription,
          url: `https://todaylocal.in/${urlNews}`,
        })
        .then(() => console.log("Successfully shared!"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Web Share API not supported on this device.");
    }
  };

  const handleShareClick = (platform) => {
    const shareUrl = `https://todaylocal.in/${urlNews}`;
    const text = `${title} - ${shortDescription}`;
    const encodedText = encodeURIComponent(text);
    const encodedUrl = encodeURIComponent(shareUrl);

    switch (platform) {
      case "whatsapp":
        window.open(`https://wa.me/?text=${encodedText}%20${encodedUrl}`);
        break;
      case "facebook":
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
        break;
      case "twitter":
        window.open(`https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`);
        break;
      default:
        console.error("Unsupported platform:", platform);
    }
  };

  return (
    <Card className="card">
      <Card.Img className="card-img" variant="top" src={`${BASE_URL}/${imageUrl}`} alt={alt || "News Image"} />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text className="card-description">{shortDescription}</Card.Text>
        <Details channel={channel} published={published} />
        <Button className="card-btn" href={urlNews} target="_self">
          Read more <ArrowIcon className="arrow-icon" />
        </Button>
      </Card.Body>
    </Card>
  );
}

NewsItem.propTypes = {
  imageUrl: PropTypes.string, // Expecting an image filename stored in DB
  alt: PropTypes.string,
  shortDescription: PropTypes.string,
  title: PropTypes.string,
  channel: PropTypes.string,
  published: PropTypes.string,
  urlNews: PropTypes.string,
};

export default NewsItem;
